import React from 'react';
import { Card } from 'react-bootstrap';
import ReactCountryFlag from "react-country-flag";
import { getCountryCode } from '../untils/stringUtils';
import './StartupCard.css';

// "Growth- series A" (registration form value) -> "Series A"
export const startupStageLabel = (stage = '') =>
    stage.replace(/^Growth-\s*series/i, 'Series');

// Marketing sample: shows only country, vertical, description, stage and fundraising ask,
// with no company name, funding bar or actions, so it can't be opened even by VIP members.
function SampleStartupCard({ startup }) {
    const countryCode = getCountryCode(startup.cityCountryHeadquarters || '');
    const ask = Number(startup.baseTarget);

    return (
        <Card className="custom-card mb-4">
            <Card.Body>
                <div className="country-flag-with-name">
                    <ReactCountryFlag countryCode={countryCode} svg style={{ width: '2em', height: '2em' }} title={startup.cityCountryHeadquarters} />
                    <span>{startup.countryLabel || startup.cityCountryHeadquarters}</span>
                </div>
                <div className="stats mt-3">
                    <div className="stat-item">
                        <span className="stat-title">Vertical: </span>
                        <span className="stat-value">{startup.vertical}</span>
                    </div>
                </div>
                <Card.Text className="mt-2">{startup.description}</Card.Text>
                <div className="stats mt-3">
                    <div className="stat-item">
                        <span className="stat-title">Startup stage: </span>
                        <span className="stat-value">{startupStageLabel(startup.startupStage)}</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-title">Fundraising / M&amp;A ask: </span>
                        <span className="stat-value">{ask ? `US$${ask.toLocaleString('en-US')}` : startup.raiseRange}</span>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
}

export default SampleStartupCard;
